export interface MessageOptions {
    message: string
    dangerouslyUseHTMLString?: boolean
    duration?: number
    showClose?: boolean
}

export const Message = Symbol.for('Message');

/**
 * Represents a message utility that provides methods for displaying different types of messages.
 */
export interface Message {
    /**
     * Closes all open messages.
     */
    closeAll(): void;

    /**
     * Displays a success message.
     * @param options - The options for the success message.
     */
    success(options: MessageOptions): void;

    /**
     * Displays a warning message.
     * @param options - The options for the warning message.
     */
    warning(options: MessageOptions): void;

    /**
     * Displays an information message.
     * @param options - The options for the information message.
     */
    info(options: MessageOptions): void;

    /**
     * Displays an error message.
     * @param options - The options for the error message.
     */
    error(options: MessageOptions): void;
}
